// ============================================
// COMPONENT - Page Tracker for GTM
// ============================================

import { usePageTracking } from '../hooks/usePageTracking';

/**
 * Componente que debe estar dentro del Router
 * para rastrear cambios de página con GTM
 */
export const PageTracker = () => {
  usePageTracking();
  return null; // No renderiza nada, solo ejecuta el hook
};
